import { Component, ElementRef, Input, SecurityContext, ViewChild } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatStepper, MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import Swal from 'sweetalert2';

import { MatCheckboxModule } from '@angular/material/checkbox';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatTooltipModule } from '@angular/material/tooltip';
import { HeaderComponent } from '../../header/header.component';
import { FooterComponent } from '../../footer/footer.component';
import { DireccionDirective } from '../../../validaciones/directives/direccion.directive';
import { NameDirective } from '../../../validaciones/directives/name.directive';
import { NumericDirective } from '../../../validaciones/directives/numeric.directive';
import { AlphanumericDirective } from '../../../validaciones/directives/alphanumeric.directive';
import { PlacaDirective } from '../../../validaciones/directives/placa.directive';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatIconModule } from '@angular/material/icon';
import { lettersDirective } from '../../../validaciones/directives/lettersDirective.directive';
import { CatEfectoCertificado } from '../../../service/catEfectoCertificado.service';
import { CatCoberturaCertificados } from '../../../service/catCoberturaCertificados.service';
import { SolicitarCertificadoForaneoFisica } from '../../../service/solicitarCertificadoForaneoFisica.service';
import { SolicitudVo } from '../../../pojos/solicitudVo';
import { ResponsePropietarioFisica } from '../../../pojos/responsePropietarioFisica';
import { combineLatest, debounceTime, distinctUntilChanged, filter, Subscription } from 'rxjs';
import { Localidades } from '../../../pojos/localidades.modelo';
import { CatologosGenericosService } from '../../../service/catalogosGenericos.service';
import { HttpErrorResponse, HttpEvent, HttpEventType } from '@angular/common/http';
import { DefaultErrorMessage, ErrorMessages } from '../../catalogoErrores/error-messages';
import { ImprimirSolicitudCdniGenerico } from '../../../service/imprimirSolicitudCdniGenerico.service';
import { DocumentoService } from '../../../service/cargarDocumentos.service';
import { EliminarDocumentos } from '../../../service/eliminarDocumentos.service';
import { ConsultarEstatusVehiculoService } from '../../../service/consultarEstatusVehiculoFisica.service';
import { EstatusVehiculoResponse } from '../../../pojos/estatusVehiculoResponse';
import { ActivatedRoute } from '@angular/router';
import { EditarSolicitudForaneaFisica } from '../../../service/editarSolicitudForaneaFisica.service';
import { Documento, EstatusVehiculoResponseEdicion } from '../../../pojos/estatusVehiculoResponseEdicion';
import { DocumentoTramite } from '../../../pojos/documentoTramiteForaneaVo';
import { GuardarCambiosEdicionForaneaFisica } from '../../../service/guardarCambiosEdicionForaneaFisica.service';

@Component({
  selector: 'app-persona-fisica-foranea-edicion',
  imports: [ReactiveFormsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatOptionModule,
    HeaderComponent,
    FooterComponent,
    MatCheckboxModule,
    FormsModule,
    CommonModule,
    MatSelectModule,
    MatTooltipModule,
    MatIconModule,

    lettersDirective,
    DireccionDirective,
    NameDirective,
    NumericDirective,
    AlphanumericDirective,
    PlacaDirective,],
  templateUrl: './persona-fisica-foranea-edicion.component.html',
  styleUrl: './persona-fisica-foranea-edicion.component.css'
})
export class PersonaFisicaForaneaEdicionComponent {
@ViewChild('stepper') stepper!: MatStepper;
  @Input() estatusVehiculoResponse!: EstatusVehiculoResponse;
  @Input() estatusVehiculoResponseEdicion!: EstatusVehiculoResponseEdicion;
  @Input() solicitudVo!: SolicitudVo;
  @Input() efectosCertificados: any[] = [];
  @Input() coberturaCertificados: any[] = [];
  @Input() listLocalidades!: Localidades; //Modelo de localidades de servicio generico INEGI
  @Input() localidades: Array<any> = []; //Arreglo para recibir las localides del servicios de INEGI
  @Input() documentoList: DocumentoTramite[] = [];
  public estados: string[] = [];
  public municipios: string[] = [];
  public localidadesLista: string[] = [];
  @Input() localidadesVo!: Localidades;
  estado: string = '';
  municipio: string = '';
  uploadProgress: number[] = [0, 0, 0, 0];
  isUploading: boolean[] = [false, false, false, false];
  documentos = [
    {id: 8, titulo: 'SOLICITUD', formControlName: '',estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''},
    {id: 3, titulo: 'FACTURA', formControlName: '', estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''},
    {id: 4, titulo: 'INE', formControlName: '', estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''},
    {id: 7, titulo: 'REPUVE', formControlName: '', estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''},
    {id: 9, titulo: 'TENENCIA Y/O REFRENDO', formControlName: '', estadoSubida: 'PENDIENTE', urlVisor: '', rawUrl: ''}
  ];
  nombreArchivos: string[] = ['', '', '', '',''];
  documentosSubidos: { identificador: string; idDocumento: number; }[] = [];
  identificadoresAnteriores: string[] = []; // <-- ya lo manejas por índice
  idsDocumentoAnteriores: number[] = [];   // <-- también por índice
  dataParam: string | null = null;
  checkboxSolicitud: boolean = false;
  checkboxFactura: boolean = false;
  checkboxINE: boolean = false;
  checkboxRepuve: boolean = false;
  checkboxTenenciaRefrendo: boolean = false;
  idSolicitud = 0;
  idFactura = 0;
  idINE = 0;
  idRepuve = 0;
  idRefrendoTenencia = 0;
  //********************************************* INICIALIZADOR DE FORMGROUP ************************************************//

  PrimerFormGroup!: FormGroup;
  SegundoGrupo!: FormGroup;
  TercerFormGroup!: FormGroup;
  CuartoFormGroup!: FormGroup;
  QuintoFormGroup!: FormGroup;
  SextoFormGroup!: FormGroup;
  SeptimoFormGroup!: FormGroup;

  mostrarSpinner = false;
  isLinear = false;

  //********************************************* VARIABLES INICIALIZADAS PARA DOCUMENTOS PDF - IFRAME ************************************************//

  // SOLICITUD
  archivoPDF1: File | null = null;
  pdfURL1: any = null;
  // isUploading = false;
  // uploadProgress = 0;

  // FACTURA
  archivoPDF2: File | null = null;
  pdfURL2: any = null;
  isUploading2 = false;
  uploadProgress2 = 0;

  // INE
  archivoPDF3: File | null = null;
  pdfURL3: any = null;
  isUploading3 = false;
  uploadProgress3 = 0;

  // REPUVE
  archivoPDF4: File | null = null;
  pdfURL4: any = null;
  isUploading4 = false;
  uploadProgress4 = 0;

  // TENENCIA
  archivoPDF5: File | null = null;
  pdfURL5: any = null;
  isUploading5 = false;
  uploadProgress5 = 0;
  subscription!: Subscription;

  constructor(
    private _formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private sanitizer: DomSanitizer,
    private catEfectoCertificadoService: CatEfectoCertificado,
    private catCoberturaCertificadoService: CatCoberturaCertificados,
    private guardarEdicionForaneaFisica: GuardarCambiosEdicionForaneaFisica,
    private localidadesService: CatologosGenericosService,
    private imprimirSolicitudCdniGenerico: ImprimirSolicitudCdniGenerico,
    private cargarDocumentosService: DocumentoService,
    private eliminarDocumentosService: EliminarDocumentos,
    private editarSolicitudForaneaService: EditarSolicitudForaneaFisica
  )
   {
      this.solicitudVo = new SolicitudVo();
      this.localidadesVo = new Localidades();
      this.catCoberturaCertificados();
      this.catEfectoCertificado();
   }

  //********************************************* VARIABLES INICIALIZADAS PARA VALIDAR CAMPOS VACIOS ************************************************//

  ngOnInit(): void {
    this.PrimerFormGroup = this._formBuilder.group({
      niv: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(17),
        ],
      ],
      placa: [
        '',
        [
          Validators.required,
          Validators.minLength(1),
          Validators.maxLength(10),
        ],
      ],

      motivoSolicitud: ['', Validators.required],
      certificadoPor: ['', Validators.required],
      tipoServicio: ['', Validators.required],
      //categoria: ['', Validators.required],
      marca: ['', Validators.required],
      submarca: ['', Validators.required],
      modelo: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4),],],
      motor: ['', Validators.required],
      refrendo: ['', [Validators.required, Validators.minLength(4), Validators.maxLength(4),],],
      repuve: ['', Validators.required],
    });

    this.SegundoGrupo = this._formBuilder.group({
      rfc: [
        '',
        [
          Validators.required,
          Validators.minLength(13),
          Validators.maxLength(13),
          Validators.pattern(/^[A-Z]{4}[0-9]{6}[A-Z0-9]{3}$/),
        ],
      ],
      curp: [
        '',
        [
          Validators.required,
          Validators.minLength(18),
          Validators.maxLength(18),
          Validators.pattern(
            /^([A-Z][AEIOUX][A-Z]{2}\d{2}(?:0[1-9]|1[0-2])(?:0[1-9]|[12]\d|3[01])[HM](?:AS|B[CS]|C[CLMSH]|D[FG]|G[TR]|HG|JC|M[CNS]|N[ETL]|OC|PL|Q[TR]|S[PLR]|T[CSL]|VZ|YN|ZS)[B-DF-HJ-NP-TV-Z]{3}[A-Z\d])(\d)$/
          ),
        ],
      ],
      nombre: ['', Validators.required],
      apellidoPaterno: ['', Validators.required],
      apellidoMaterno: ['', Validators.required],
      sexo: ['', Validators.required],
      fechaNacimiento: ['', Validators.required],
    });

    this.TercerFormGroup = this._formBuilder.group({
      calle: ['', Validators.required],
      numeroExterior: ['', Validators.required],
      numeroInterior: [''],
      codigoPostal: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(5),],],
      estado: ['', Validators.required],
      municipio: ['', Validators.required],
      localidad: ['', Validators.required],
    });

    this.CuartoFormGroup = this._formBuilder.group({
      numeroTelefono: [
        '',
        [Validators.required, Validators.pattern(/^\d{10}$/)],
      ],
      correoElectronico: [
        '',
        [
          Validators.required,
          Validators.pattern(
            /^[a-zA-Z0-9._%+-]{3,}@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/
          ),
        ],
      ],
    });

    this.QuintoFormGroup = this._formBuilder.group({
      descargarDocumento: [false, Validators.requiredTrue],
    });

    this.SextoFormGroup = this._formBuilder.group({
     
    });

    this.SeptimoFormGroup = this._formBuilder.group({
      terminosCondiciones: [false, Validators.requiredTrue],
    });

    //********************************************* VALIDACIONES REACTIVAS 1-3 ************************************************//

    // 🔹 Aplicamos validaciones en tiempo real a TODOS los formularios
    this.inicializarValidacionesReactivas(this.PrimerFormGroup);
    this.inicializarValidacionesReactivas(this.SegundoGrupo);
    this.inicializarValidacionesReactivas(this.TercerFormGroup);
    this.inicializarValidacionesReactivas(this.CuartoFormGroup);
    this.inicializarValidacionesReactivas(this.QuintoFormGroup);
    this.inicializarValidacionesReactivas(this.SextoFormGroup);
    this.inicializarValidacionesReactivas(this.SeptimoFormGroup);
    //********************************************* VALIDACION DE NIV Y PLACA PARA OBTENER ESOS VALORES ************************************************//
      

    //********************************************* VALIDACION DE NIV Y PLACA PARA OBTENER ESOS VALORES ************************************************//


  //********************************************* VALIDACION DE CODIGO POSTAL PARA OBTENER ESOS VALORES ************************************************//
      this.TercerFormGroup.get('codigoPostal')?.valueChanges
    .pipe(
      debounceTime(300),
      distinctUntilChanged(),
      filter((valor: string) => valor?.length === 5)
    )
    .subscribe((codigoPostal: string) => {
      this.obtenerLocalidades(codigoPostal);
    });
 //********************************************* VALIDACION DE CODIGO POSTAL PARA OBTENER ESOS VALORES ************************************************//
  this.dataParam = this.route.snapshot.paramMap.get('data'); 
    this.obtenerDatosEditarForaneo(this.dataParam?.substring(5));
 
 this.documentosSubidos = new Array(this.documentos.length).fill(null);
}



  //******************METODOS y llamada a consumos de servicio********************************//
    obtenerDatosEditarForaneo(data:any) {
    this.mostrarSpinner = true;
      this.editarSolicitudForaneaService.editarEstatalFisica(this.dataParam?.substring(5)).subscribe({
        next: (resp: EstatusVehiculoResponseEdicion) => {
          this.estatusVehiculoResponseEdicion = resp;

          this.PrimerFormGroup.patchValue({
            categoria: '',
            marca: '',
            submarca: '',
            modelo: '',
            motor: '',
            refrendo: '',
            repuve: ''
          });

          this.PrimerFormGroup.patchValue({
          niv:this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strNiv,
          placa: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strPlaca,
          motivoSolicitud: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.intIdMotivoSolicitud,
          certificadoPor: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.intIdCertificadoPor,
          tipoServicio: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.intIdTipoServicio,
          categoria: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strCategoria,
          marca: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strMarca,
          submarca: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strSubMarca,
          modelo: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strModelo,
          motor: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strNoMotor,
          refrendo: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strAnioRefrendo,
          repuve: this.estatusVehiculoResponseEdicion.datosVehiculoResponseVo.strRepuve
        });

        this.SegundoGrupo.patchValue({
          rfc: this.estatusVehiculoResponseEdicion.datosPersonaResponseVo.strRfc,
          curp: this.estatusVehiculoResponseEdicion.datosPersonaResponseVo.strCurp,
          nombre: this.estatusVehiculoResponseEdicion.datosPersonaResponseVo.strNombre,
          apellidoPaterno: this.estatusVehiculoResponseEdicion.datosPersonaResponseVo.strApPaterno,
          apellidoMaterno: this.estatusVehiculoResponseEdicion.datosPersonaResponseVo.strApMaterno,
          sexo: this.estatusVehiculoResponseEdicion.datosPersonaResponseVo.strSexo,
          fechaNacimiento: this.estatusVehiculoResponseEdicion.datosPersonaResponseVo.strFechaNacimiento,
          calle: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strCalle,
          numeroExterior: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strNoExterior,
          numeroInterior: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strNoInterior,
          codigoPostal: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strCodigoPostal,
          estado: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strEstado,
          municipio: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strMunicipio,
          localidad: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strLocalidad
        });

        this.TercerFormGroup.patchValue({
          calle: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strCalle,
          numeroExterior: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strNoExterior,
          numeroInterior: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strNoInterior,
          codigoPostal: this.estatusVehiculoResponseEdicion.datosDomicilioResponseVo.strCodigoPostal
        });

        this.CuartoFormGroup.patchValue({
          numeroTelefono: this.estatusVehiculoResponseEdicion.datosDeContactoResponseVo.strTelefono,
          correoElectronico: this.estatusVehiculoResponseEdicion.datosDeContactoResponseVo.strCorreoElectronico
        })

        this.mostrarSpinner = false;
        this.extractBirthday();
        this.extraerSexoDesdeCurp();
        this.mostrarPDF(this.estatusVehiculoResponseEdicion.documentoList ?? []);
        
        },
         error: (error: HttpErrorResponse) =>{
                      this.mostrarSpinner = false;
                    let message = DefaultErrorMessage;
        
                    if(error instanceof HttpErrorResponse){
                      const statusCode = error.status;
        
                      // Si viene un código de error personalizado desde el backend:
                        const customCode = error.error?.codigo; // <- Esto depende de tu backend
        
                        if(customCode && ErrorMessages[customCode]){
                            message = ErrorMessages[customCode];
                        }else if (ErrorMessages[statusCode]) {
                          message = ErrorMessages[statusCode];
                        }
                      }
                     Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: message,
        
                    });
                    }
      })
    }



    mostrarPDF(documentos: Documento[]){
        documentos.forEach(doc =>{
          const urlDescarga = `https://af-documentos-pdf-cdni.sefintlax.gob.mx/${doc.url.substring(20)}`;
          const safeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(urlDescarga);
          const estatusBool = doc.estatus === 'true';
  
          switch (doc.idDocumentoTramite) {
            case 8: // Solicitud
          this.pdfURL1 = safeUrl;
          this.archivoPDF1 = new File(['placeholder'], doc.nombreDocumento || 'solicitud.pdf', {
          type: 'application/pdf',
          });
          this.checkboxSolicitud = estatusBool;
          this.idSolicitud = doc.idDocumento;
          this.PrimerFormGroup.get('solicitud')?.setValue(estatusBool);
          break;
        case 3: // Factura
          this.pdfURL2 = safeUrl;
          this.archivoPDF2 = new File(['placeholder'], doc.nombreDocumento || 'factura.pdf', {
          type: 'application/pdf',
        });
          this.checkboxFactura = estatusBool;
          this.idFactura = doc.idDocumento;
          this.PrimerFormGroup.get('factura')?.setValue(estatusBool);
          break;
        case 4: // INE
          this.pdfURL3 = safeUrl;
          this.archivoPDF3 = new File(['placeholder'], doc.nombreDocumento || 'ine.pdf', {
          type: 'application/pdf',
        });
          this.checkboxINE = estatusBool;
          this.idINE = doc.idDocumento;
          this.PrimerFormGroup.get('ine')?.setValue(estatusBool);
          break;
        case 7: // REPUVE
          this.pdfURL4 = safeUrl;
          this.archivoPDF4 = new File(['placeholder'], doc.nombreDocumento || 'repuve.pdf', {
          type: 'application/pdf',
        });
          this.checkboxRepuve = estatusBool;
          this.idRepuve = doc.idDocumento;
          this.PrimerFormGroup.get('repuve2')?.setValue(estatusBool);
          break;
           case 9: // TENENCIA Y/O REFRENDO
          this.pdfURL5 = safeUrl;
          this.archivoPDF5 = new File(['placeholder'], doc.nombreDocumento || 'tenencia.pdf', {
          type: 'application/pdf',
        });
          this.checkboxTenenciaRefrendo = estatusBool;
          this.idRefrendoTenencia = doc.idDocumento;
          this.PrimerFormGroup.get('tenencia')?.setValue(estatusBool);
          break;
          }
          
        });

        this.documentoList = documentos.map(doc => ({
      idDocumento: doc.idDocumento,
      url: doc.url,
      idDocumentoTramite: doc.idDocumentoTramite,
      nombreDocumento: doc.nombreDocumento
    }))
      }


     obtenerUrlRelativa(url: any): string {
  const trustedUrl = this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, url);
  if (trustedUrl) {
    const index = trustedUrl.indexOf('uploads/');
    return index !== -1 ? trustedUrl.substring(index) : '';
  }
  return '';
} 


   catCoberturaCertificados(){
  this.catCoberturaCertificadoService.catCoberturaCertificado().subscribe({
    next: (data:any) => {
      this.coberturaCertificados = data;
    }
  });
 }


 catEfectoCertificado(){
  this.catEfectoCertificadoService.catEfectoCertificado().subscribe({
    next: (data: any) => {
      this.efectosCertificados = data;
    }
  });
}

 onChangeCoberturaCertificados(event:any){
  this.solicitudVo.strCertificadoPor = event.target.value;
}


 onChangeEfectoCertificado(event:any){
  this.solicitudVo.strMotivoSolicitud = event.target.value;
}

onChangeTipoServicio(event:any){
  this.solicitudVo.strTipoServicio = event.target.value;
}

obtenerLocalidades(codigoPostal: string): void {
   const cp = codigoPostal.padStart(5, '0');
  this.localidadesService.getLocalidades(cp).subscribe((data: any[]) => {
    this.localidades = data;

    if (data && data.length > 0) {
      const localidadSeleccionada = data[0];
      const estadoSeleccionado = localidadSeleccionada.descripcionidEstadoPais?.toUpperCase().trim();

      if(estadoSeleccionado === 'TLAXCALA'){
        Swal.fire({
          icon: 'error',
          title: 'Estado no Válido',
          html: `<b>Este es un trámite para vehículos foráneos.</b> Si su domicilio está en TLAXCALA, por favor utilice el trámite para vehículos ESTATALES.`,
          confirmButtonColor: '#d33',
          confirmButtonText: 'Aceptar',
          allowEscapeKey: false, // Deshabilita cerrar con ESC
          allowEnterKey: false, // Deshabilita cerrar con ENTER
          allowOutsideClick: false, // Deshabilita cerrar haciendo clic fuera
        });

        // Limpia los campos relacionados para evitar que se guarden
        this.TercerFormGroup.patchValue({
          estado: '',
          municipio: '',
          localidad: ''
        });

        return; // Evita continuar llenando los datos
      }

      this.localidadesVo.lonIdMunicipio = localidadSeleccionada.idMunicipioCodigoPostal;
      this.localidadesVo.intCodigoPostal = localidadSeleccionada.idCodigoPostal;
      this.localidadesVo.strLocalidad = localidadSeleccionada.asentamiento;
      this.localidadesVo.strMunicipio = localidadSeleccionada.descripcionIdMunicipioCodigoPostal;

      this.TercerFormGroup.patchValue({
        estado: localidadSeleccionada.descripcionidEstadoPais,
        municipio: localidadSeleccionada.descripcionIdMunicipioCodigoPostal,
        localidad: localidadSeleccionada.asentamiento
      });

      this.localidadesLista = data.map(loc => loc.asentamiento); // para el select
    }
  });
}

descargarDocumento() {
      const primerGrupo = this.PrimerFormGroup.getRawValue();
      const segundoGrupo = this.SegundoGrupo.getRawValue();
      const tercerGrupo = this.TercerFormGroup.getRawValue();

      const strNombreCompleto = `${segundoGrupo.nombre || ''} ${segundoGrupo.apellidoPaterno || ''} ${segundoGrupo.apellidoMaterno || ''}`.trim();
      const strRfc = segundoGrupo.rfc || '';
      const strCurp = segundoGrupo.curp || '';

      const calle = tercerGrupo.calle || '';
      const numExt = tercerGrupo.numeroExterior || '';
      const numInt = tercerGrupo.numeroInterior || '';
      const codigoPostal = tercerGrupo.codigoPostal || '';
      const strDomicilio = `${calle} ${numExt}${numInt ? ' Int ' + numInt : ''} ${codigoPostal}`.trim();

      const strMunicipio = tercerGrupo.municipio || '';
      const strEstado = tercerGrupo.estado || '';

      const motivoSeleccionado = this.efectosCertificados.find(
      m => m.id_efecto_certificado == primerGrupo.motivoSolicitud);
      const strGarantias = motivoSeleccionado?.motivo_de_solicitud || '';

      const strNiv = primerGrupo.niv || '';
      const strPlaca = primerGrupo.placa || '';
      const strMarca = primerGrupo.marca || '';
      const strEstadoVehiculo = tercerGrupo.estado || '';
      const strModelo = primerGrupo.modelo || '';
      const strRefrendo = primerGrupo.refrendo || '';

      const tipoServicioId = primerGrupo.tipoServicio;
      const strTipoServicio = tipoServicioId === '1' ? 'PÚBLICO' : tipoServicioId === '2' ? 'PRIVADO' : '';

      const strNumeroMotor = primerGrupo.motor || '';
      const strRepuve = primerGrupo.repuve || '';

      const strRazonSocial = '';
      const strRfcRepresentante = '';
      const strTipoPersona = 'F';

    Swal.fire({
      html: `<h4>Descargando documento <b style="color: #A11A5C">SOLICITUD DE CERTIFICADO DE NO INFRACCIÓN</b><hr>espere un momento...</h4>`,
      didOpen: () => {
        Swal.showLoading();
      },
      timer: 4000,
      timerProgressBar: true,
      allowOutsideClick: false,
      allowEscapeKey: false,
      allowEnterKey: false,
      showConfirmButton: false,
    });


    this.imprimirSolicitudCdniGenerico.imprimirSolicitudCdniGenerico(
    strNombreCompleto,
    strRfc,
    strRfcRepresentante,
    strRazonSocial,
    strCurp,
    strDomicilio,
    strMunicipio,
    strEstado,
    strGarantias,
    strNiv,
    strPlaca,
    strMarca,
    strEstadoVehiculo,
    strModelo,
    strRefrendo,
    strTipoServicio,
    strNumeroMotor,
    strRepuve,
    strTipoPersona).subscribe({
      next: (blob: Blob) =>{
    const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'solicitud_cdni_foraneo.pdf';
        a.click();
        window.URL.revokeObjectURL(url);
        Swal.close();
      },
       error: (error) => {
      Swal.fire('Error', 'Ocurrió un error al generar el documento.', 'error');
    }
    });
  }


  subirDocumento(rfc: string, idDocumento: number, archivo: File): void {
  //this.documentos[index].estadoSubida ='SUBIENDO';
 const doc = this.documentos.find(d => d.id === idDocumento);
  if (!doc) {
    console.error('Documento no encontrado con id:', idDocumento);
    return;
  }
  this.cargarDocumentosService.subirDocumentoPdf(rfc, idDocumento, archivo).subscribe({
    next: (event: HttpEvent<any>) => {
      if (event.type === HttpEventType.UploadProgress && event.total){
        const progreso = Math.round((100 * event.loaded) / event.total);
         //this.isUploading[index] = true;
         //this.uploadProgress[index] = progreso;
      } else if (event.type === HttpEventType.Response) {
        //this.isUploading[index] = false;

        //this.documentos[index].estadoSubida = 'SUBIDO';
        const respuesta = event.body; // Aquí accedes a la respuesta del servicio

         //this.identificadoresAnteriores[index] = respuesta.identificador;
         //this.idsDocumentoAnteriores[index] = respuesta.idDocumento;
       

         Swal.fire({
                  toast: true,
                  position: 'top-end',
                  icon: 'success',
                  title: `${doc.titulo} subido con éxito`,
                  showConfirmButton: false,
                  timer: 3000
                });
      }
    },
    error: () => {
      //this.isUploading[index] = false;
      //this.documentos[index].estadoSubida = 'ERROR';
      Swal.fire({
              toast: true,
              position: 'top-end',
              icon: 'error',
              title: `No se pudo subir el documento ${doc.titulo}.`,
              showConfirmButton: false,
              timer: 3000
            });
    }
  });
}
 //*******************METODOS y llamada a consumos de servicio********************************//



  //********************************************* VALIDACIONES REACTIVAS 2-3 ************************************************//

  private inicializarValidacionesReactivas(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((campo) => {
      formGroup.get(campo)?.valueChanges.subscribe(() => {
        this.actualizarEstilosCampo(campo);
      });
    });
  }

  //********************************************* VALIDACIONES REACTIVAS 3-3 ************************************************//

  private actualizarEstilosCampo(campo: string) {
    const control =
      this.SeptimoFormGroup.get(campo) ||
      this.SextoFormGroup.get(campo) ||
      this.QuintoFormGroup.get(campo) ||
      this.CuartoFormGroup.get(campo) ||
      this.TercerFormGroup.get(campo) ||
      this.SegundoGrupo.get(campo) ||
      this.PrimerFormGroup.get(campo);

      if(!control) return;
    const fieldElement = document.querySelector(`[formControlName="${campo}"]`);

    if (fieldElement) {
      if (control?.valid) {
        fieldElement.classList.remove('is-invalid');
        fieldElement.classList.add('is-valid');
      } else if (!control.value) {
        fieldElement.classList.remove('is-valid');
      fieldElement.classList.remove('is-invalid');
      } else {
        fieldElement.classList.add('is-invalid');
        fieldElement.classList.remove('is-valid');
      }
    }
  }

  //********************************************* STEPPER ************************************************//

  /** Validación y navegación **/
  validarYContinuar(campos: { grupo: FormGroup; nombres: string[] }) {
    let todosValidos = true;

    campos.nombres.forEach((campo) => {
      const control = campos.grupo.get(campo);
      const fieldElement = document.querySelector(
        `[formControlName="${campo}"]`
      );

      if(control){
        control.markAsTouched({onlySelf:true});
        control.updateValueAndValidity();
      }

      if (control && control.disabled) return;

      if (control && control.invalid && !control.disabled) {
        todosValidos = false;
        Swal.fire({
          html: this.mensajeError(campo),
          icon: 'warning',
          confirmButtonColor: '#A11A5C',
          confirmButtonText: 'Confirmar',
          didOpen: () => fieldElement?.classList.add('is-invalid'),
        });
      } else if (fieldElement && (control?.valid || control?.disabled)) {
        fieldElement.classList.remove('is-invalid');
        fieldElement.classList.add('is-valid');
      }
    });

    if (todosValidos) this.stepper.next();
  }

  //********************************************* MENSAJES PERSONALIZADOS ************************************************//

  mensajeError(campo: string): string {
    const mensajes: any = {
      //Primera seccion
      niv: 'El campo <b> NIV de los Datos del Vehículo </b> no debe estar vacío.',
      placa:
        'El campo <b> Placa de los Datos del Vehículo </b> no debe estar vacío.',
      motivoSolicitud:
        'El campo <b> Motivo Solicitud de los Datos del Vehículo </b> debe estar seleccionado.',
      certificadoPor:
        'El campo <b> Certificado Por: de los Datos del Vehículo </b> debe estar seleccionado.',
      tipoServicio:
        'El campo <b> Tipo Servicio de los Datos del Vehículo </b> debe estar seleccionado.',
      categoria:
        'El campo <b> Categoria de los Datos del Vehículo </b> no debe estar vacío.',
      marca:
        'El campo <b> Marca de los Datos del Vehículo </b> no debe estar vacío.',
      submarca:
        'El campo <b> Submarca de los Datos del Vehículo </b> no debe estar vacío.',
      modelo:
        'El campo <b> Modelo de los Datos del Vehículo </b> no debe estar vacío.',
      motor:
        'El campo <b> Motor de los Datos del Vehículo </b> no debe estar vacío.',
      refrendo:
        'El campo <b> Refrendo de los Datos del Vehículo </b> no debe estar vacío.',
      repuve:
        'El campo <b> repuve de los Datos del Vehículo </b> no debe estar vacío.',

      //Segunda seccion
      rfc:
        'Por favor verifica que el campo <b> RFC </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato válido: </b> LLLL000000AAA',
      curp:
        'Por favor verifica que el campo <b> CURP </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato válido: </b> LLLL000000LLLLLLA0',
      nombre:
        'El campo <b> Nombre de los Datos Personales </b> no debe estar vacío.',
      apellidoPaterno:
        'El campo <b> Apellido Paterno de los Datos Personales </b> no debe estar vacío.',
      apellidoMaterno:
        'El campo <b> Apellido Materno de los Datos Personales </b> no debe estar vacío.',
      sexo:
        'El campo <b> Sexo de los Datos Personales </b> no debe estar vacío.',
      fechaNacimineto:
        'El campo <b> Fecha Nacimiento de los Datos Personales</b> no debe estar vacío.',

      //Tercera seccion
      calle:
        'El campo <b> Calle del Domicilio </b> no debe estar vacío.',
      numeroExterior:
        'El campo <b> Numero Exterior del Domicilio </b> no debe estar vacío.',
      codigoPostal:
        'El campo <b> Codigo Postal del Domicilio </b> no debe estar vacío.',
      estado:
        'El campo <b> Estado del Domicilio </b> debe estar seleccionado.',
      municipio:
        'El campo <b> Municipio del Domicilio </b> debe estar seleccionado.',
      localidad:
        'El campo <b> Localidad del Domicilio </b> debe estar seleccionado.',


      //Cuarta seccion
      correoElectronico:
        'Por favor verifica que el campo <b> Correo Electrónico de los Medios de Contacto </b> ' +
        'no este vacío o que el formato proporcionado sea válido.' +
        '<br>' +
        '<b> formato correo: </b> nombre@ejemplo.com',
      numeroTelefono:
        'El campo <b> Número Teléfono de los Medios de Contacto </b> debe contener 10 números.',

      //Quinta seccion
      descargarDocumento:
        'Para continuar a la sección de <b>Documentos</b> primero debes marcar el cuadro que aparece en la parte inferior de esta sección',

      //Sexta seccion
      solicitud: 'El documento <b>SOLICITUD</b> no ha sido seleccionado',
      factura: 'El documento <b>FACTURA</b> no ha sido seleccionado',
      ine: 'El documento <b>INE</b> no ha sido seleccionado',
      repuve2: 'El documento <b>REPUVE</b> no ha sido seleccionado',
      tenencia: 'El documento <b>TENENCIA Y/O REFRENDO</b> no ha sido seleccionado'
    };

    return mensajes[campo] || 'Campo inválido.';
  }

  //********************************************* BOTONES SIGUIENTE ************************************************//

  nextButtonClick() {
    this.validarYContinuar({
      grupo: this.PrimerFormGroup,
      nombres: [
        'repuve',
        'refrendo',
        'motor',
        'modelo',
        'submarca',
        'marca',
        'categoria',
        'tipoServicio',
        'certificadoPor',
        'motivoSolicitud',
        'placa',
        'niv',
      ],
    });
  }

  nextButtonClick2() {
    this.validarYContinuar({
      grupo: this.SegundoGrupo,
      nombres: ['fechaNacimiento', 'sexo', 'apellidoMaterno', 'apellidoPaterno', 'nombre', 'curp', 'rfc'],
    });
  }

  nextButtonClick3() {
    this.validarYContinuar({
      grupo: this.TercerFormGroup,
      nombres: ['localidad', 'municipio', 'estado', 'codigoPostal', 'numeroInterior', 'numeroExterior', 'calle'],
    });
  }

  nextButtonClick4() {
    this.validarYContinuar({
      grupo: this.CuartoFormGroup,
      nombres: ['correoElectronico', 'numeroTelefono'],
    });
  }

  nextButtonClick5() {
    this.validarYContinuar({
      grupo: this.QuintoFormGroup,
      nombres: ['descargarDocumento'],
    });
  }

  nextButtonClick6() {
    this.validarYContinuar({
      grupo: this.SextoFormGroup,
      nombres: ['tenencia', 'repuve2', 'ine', 'factura', 'solicitud'],
    });
  }


  nextButtonClick7() {

    this.validarYContinuar({
      grupo: this.SeptimoFormGroup,
      nombres: ['terminosCondiciones'],
    });

    const campo1 = this.SeptimoFormGroup.get('terminosCondiciones');

    const correo = this.CuartoFormGroup.get('correoElectronico')?.value;

    if (campo1 && !campo1.value) {
      Swal.fire({
        html: '<b>Debes Aceptar los Términos y Condiciones</b>',
        icon: 'warning',
        confirmButtonColor: '#A11A5C',
        confirmButtonText: 'Confirmar',
      });
      return;
    }

    const datosVehiculo = this.PrimerFormGroup.getRawValue();
    const datosPersona = this.SegundoGrupo.getRawValue();
    const datosDomicilio = this.TercerFormGroup.getRawValue();
    const datosContacto = this.CuartoFormGroup.getRawValue();

    
    const payload = {
      "dataEncript": this.dataParam?.substring(5),
      /**DATOS DEL VEHICULO**/
      "strNiv": datosVehiculo.niv,
      "strPlaca": datosVehiculo.placa,
      "strCategoria":datosVehiculo.categoria,
      "strMarca":datosVehiculo.marca,
      "strSubMarca":datosVehiculo.marca,
      "strModelo":datosVehiculo.modelo,
      "strMotor":datosVehiculo.motor,
      "strRefrendo":datosVehiculo.refrendo,
      "strRepuve":datosVehiculo.repuve,
      /**DATOS DEL VEHICULO**/

      /**DATOS DEL PROPIETARIO**/
      "strRfc": datosPersona.rfc,
      "strCurp": datosPersona.curp,
      "strNombre":datosPersona.nombre,
      "strApMaterno":datosPersona.apellidoMaterno,
      "strApPaterno":datosPersona.apellidoPaterno,
      "strSexo": datosPersona.sexo,
      "strFechaNacimiento": datosPersona.fechaNacimiento,
      /**DATOS DEL PROPIETARIO**/

      /**DOMICILIO**/
      "strCalle": datosDomicilio.calle,
      "strNumeroExterior": datosDomicilio.numeroExterior,
      "strNumeroInterior": datosDomicilio.numeroInterior,
      "strCodigoPostal": datosDomicilio.codigoPostal,
      "strEstadoFiscal": datosDomicilio.estado,
      //"strMunicipio": datosDomicilio.municipio,
      "strLocalidad": datosDomicilio.localidad,
      "intIdCodigoPostalCg": parseInt(this.localidadesVo.intCodigoPostal),
      "intIdLocalidadFiscal": this.localidadesVo.intCodigoPostal,
      "intIdMunicipioFiscal": parseInt(this.localidadesVo.lonIdMunicipio),
      /**DOMICILIO**/
        "documentoList": this.documentoList
      }
    Swal.fire({
      title: '¿Estás seguro que deseas guardar la información?',
      icon: 'question',
      confirmButtonColor: '#04B404',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
      showCancelButton: true,
      allowOutsideClick: false,
    }).then((result) => {
      if (result.value) {
          
        this.mostrarSpinner = true;
          this.guardarEdicionForaneaFisica.guardarEdicionForaneaFisica(payload).subscribe({
            next: (res: ResponsePropietarioFisica) =>{
             
              if(res.intCodigoHttp === 0){
              Swal.fire({
                icon: 'success',
                title: 'Solicitud enviada',
                html: `Su solicitud ha sido enviada correctamente. <br><br>
                Se ha enviado un correo electrónico a la dirección proporcionada <b style="color: #A11A5C">${correo}</b> para darle seguimiento.
                <hr>Le recomendamos revisar su bandeja de entrada, así como la carpeta de spam o correo no deseado, en caso de no visualizar el mensaje.`,
                confirmButtonColor: '#04B404',
                confirmButtonText: 'Continuar',
                allowEscapeKey: false, // Deshabilita cerrar con ESC
                allowEnterKey: false, // Deshabilita cerrar con ENTER
                allowOutsideClick: false, // Deshabilita cerrar haciendo clic fuera
              });
              }else if (res.intCodigoHttp === 400) {
                Swal.fire({
                            icon: 'error',
                            title: 'Error al enviar datos',
                            html: '<h4>No se pudo generar la solicitud, verifique su información he intentelo de nuevo.<br>Gracias.</p>',
                            });
              }
                this.mostrarSpinner = false;
            },
             error: (error: HttpErrorResponse) =>{
                this.mostrarSpinner = false;
              let message = DefaultErrorMessage;

              if(error instanceof HttpErrorResponse){
                const statusCode = error.status;

                // Si viene un código de error personalizado desde el backend:
                  const customCode = error.error?.codigo; // <- Esto depende de tu backend

                  if(customCode && ErrorMessages[customCode]){
                      message = ErrorMessages[customCode];
                  }else if (ErrorMessages[statusCode]) {
                    message = ErrorMessages[statusCode];
                  }
                }
              Swal.fire({
                  icon: 'error',
                  title: 'Error',
                  text: message,
              }).then(() => {
                          location.reload(); // Recargar la página después de confirmar
                        });
              }
          });
      }
    });
  }

  //********************************** SOLICITUD *********************************************//

  onFileSelecteded1(input: HTMLInputElement, idDocumentoTramite: number): void {
    const file = input.files?.[0];

    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }


      // const objectUrl = URL.createObjectURL(file);
      // this.pdfURL1 = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      // this.documentos[index].urlVisor = this.pdfURL1;
      // this.documentos[index].rawUrl = objectUrl;

      const datosPersona = this.SegundoGrupo.getRawValue();

      const rfc = datosPersona.rfc || '';
      const objectUrl = URL.createObjectURL(file);
      const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);


      

     const existente = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);
     
       if (existente) {

        Swal.fire({
            title: '¿Reemplazar archivo?',
            text: `Ya existe un archivo para "SOLICITUD DEL TRÁMITE". ¿Deseas eliminar el anterior y subir el nuevo?`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#41bd00',
            cancelButtonColor: '#C71128',
            confirmButtonText: 'Sí, reemplazar',
            cancelButtonText: 'No, cancelar'
          }).then((result) =>{
            if(result.isConfirmed){
              this.archivoPDF1 = file;
              this.pdfURL1 = pdfSafeUrl;    

            this.eliminarDocumentosService.eliminarDocumentos(existente.idDocumento, rfc, existente.nombreDocumento).subscribe({
           next: (res) => {
             if (res.status === 204) {
               
               this.subirDocumento(rfc, idDocumentoTramite, file);
             } else {
               Swal.fire('Error', 'No se pudo eliminar el documento anterior.', 'error');
             }
           },
           error: (err) => {
             if (err.status === 404) {
               
               this.subirDocumento(rfc, idDocumentoTramite, file); 
             } else {
               Swal.fire('Error', 'Error al eliminar el documento anterior.', 'error');
             }
           }
         });
        }
      });
         // Llamar a servicio para eliminar el documento existente 
       } else {
           this.archivoPDF1 = file;
           this.pdfURL1 = pdfSafeUrl;    
         // No había documento previo, subir directamente
         this.subirDocumento(rfc, idDocumentoTramite, file);
       }

    }
  }

  // Método para manejo de evento al seleccionar
  archivoSelecionadoPDF1(event: Event, index: number): void {
  }

  // Método para abrir el PDF en nueva ventana
  abrirPDFNewVentana1(): void {
    if (this.pdfURL1) {
      const url = this.pdfURL1 as SafeResourceUrl;
      window.open((url as any).changingThisBreaksApplicationSecurity, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }

  //********************************** FACTURA *********************************************//

  onFileSelecteded2(input: HTMLInputElement, idDocumentoTramite: number): void {
    const file = input.files?.[0];

    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      

      // const objectUrl = URL.createObjectURL(file);
      // this.pdfURL2 = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      // this.documentos[index].urlVisor = this.pdfURL2;
      // this.documentos[index].rawUrl = objectUrl;
      
      const datosPersona = this.SegundoGrupo.getRawValue();
      const rfc = datosPersona.rfc || '';
      const objectUrl = URL.createObjectURL(file);
      const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
            
            
            
            
            //const existente  = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);
           
             // Buscar si ya hay documento anterior cargado para este tipo
              const existente = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);
      
        if (existente) {
          Swal.fire({
              title: '¿Reemplazar archivo?',
              text: `Ya existe un archivo para "FACTURA". ¿Deseas eliminar el anterior y subir el nuevo?`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#41bd00',
              cancelButtonColor: '#C71128',
              confirmButtonText: 'Sí, reemplazar',
              cancelButtonText: 'No, cancelar'
            }).then((result) =>{
              if(result.isConfirmed){

              this.archivoPDF2 = file;
              this.pdfURL2 = pdfSafeUrl;

                this.eliminarDocumentosService.eliminarDocumentos(existente.idDocumento, rfc, existente.nombreDocumento).subscribe({
            next: (res) => {
              if (res.status === 204) {
                
                this.subirDocumento(rfc, idDocumentoTramite, file); // 👈 Subir nuevo PDF
              } else {
                Swal.fire('Error', 'No se pudo eliminar el documento anterior.', 'error');
              }
            },
            error: (err) => {
              if (err.status === 404) {
                
                this.subirDocumento(rfc, idDocumentoTramite, file); // 👈 Subir de todos modos
              } else {
                Swal.fire('Error', 'Error al eliminar el documento anterior.', 'error');
              }
            }
          });
          }
        });
          // Llamar a servicio para eliminar el documento existente          
        } else {
          this.archivoPDF2 = file;
          this.pdfURL2 = pdfSafeUrl;
          // No había documento previo, subir directamente
          this.subirDocumento(rfc, idDocumentoTramite, file);
        }
    }
  }

  // Método para manejo de evento al seleccionar
  archivoSelecionadoPDF2(event: Event, index: number): void {
   
  }

  // Método para abrir el PDF en nueva ventana
  abrirPDFNewVentana2(): void {
    if (this.pdfURL2) {
      const url = this.pdfURL2 as SafeResourceUrl;
      window.open((url as any).changingThisBreaksApplicationSecurity, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }

  //********************************** INE *********************************************//

  onFileSelecteded3(input: HTMLInputElement, idDocumentoTramite: number): void {
    const file = input.files?.[0];

    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }
      const datosPersona = this.SegundoGrupo.getRawValue();

      const rfc = datosPersona.rfc|| '';
      
      const objectUrl = URL.createObjectURL(file);
      const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
            
            //const existente  = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);
           
             // Buscar si ya hay documento anterior cargado para este tipo
              const existente = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);
      
        if (existente) {

          Swal.fire({
              title: '¿Reemplazar archivo?',
              text: `Ya existe un archivo para "INE". ¿Deseas eliminar el anterior y subir el nuevo?`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#41bd00',
              cancelButtonColor: '#C71128',
              confirmButtonText: 'Sí, reemplazar',
              cancelButtonText: 'No, cancelar'
            }).then((result) =>{
              if(result.isConfirmed){

                this.archivoPDF3 = file;
                this.pdfURL3 = pdfSafeUrl;
                // Llamar a servicio para eliminar el documento existente
          this.eliminarDocumentosService.eliminarDocumentos(existente.idDocumento, rfc, existente.nombreDocumento).subscribe({
            next: (res) => {
              if (res.status === 204) {
                
                this.subirDocumento(rfc, idDocumentoTramite, file); // 👈 Subir nuevo PDF
              } else {
                Swal.fire('Error', 'No se pudo eliminar el documento anterior.', 'error');
              }
            },
            error: (err) => {
              if (err.status === 404) {
                
                this.subirDocumento(rfc, idDocumentoTramite, file); // 👈 Subir de todos modos
              } else {
                Swal.fire('Error', 'Error al eliminar el documento anterior.', 'error');
              }
            }
          });
          }
        });  
        } else {
          this.archivoPDF3 = file;
          this.pdfURL3 = pdfSafeUrl;
          // No había documento previo, subir directamente
          this.subirDocumento(rfc, idDocumentoTramite, file);
        }
    }

  }

  // Método para manejo de evento al seleccionar
  archivoSelecionadoPDF3(event: Event, index: number): void {
    //console.log('Archivo seleccionado (evento):', event);
  }

  // Método para abrir el PDF en nueva ventana
  abrirPDFNewVentana3(): void {
    if (this.pdfURL3) {
      const url = this.pdfURL3 as SafeResourceUrl;
      window.open((url as any).changingThisBreaksApplicationSecurity, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }

  //********************************** REPUVE *********************************************//

  onFileSelecteded4(input: HTMLInputElement, idDocumentoTramite: number): void {
    const file = input.files?.[0];
    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      // const objectUrl = URL.createObjectURL(file);
      // this.pdfURL4 = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      // this.documentos[index].urlVisor = this.pdfURL4;
      // this.documentos[index].rawUrl = objectUrl;

      const datosPersona = this.SegundoGrupo.getRawValue();

      const rfc = datosPersona.rfc || '';
      
      const objectUrl = URL.createObjectURL(file);
      const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);                 
            //const existente  = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);
           
             // Buscar si ya hay documento anterior cargado para este tipo
              const existente = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);
      
        if (existente) {

          Swal.fire({
          title: '¿Reemplazar archivo?',
          text: `Ya existe un archivo para "REPUVE". ¿Deseas eliminar el anterior y subir el nuevo?`,
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#41bd00',
          cancelButtonColor: '#C71128',
          confirmButtonText: 'Sí, reemplazar',
          cancelButtonText: 'No, cancelar'
          }).then((result) =>{
            if(result.isConfirmed){

              this.archivoPDF4 = file;
            this.pdfURL4 = pdfSafeUrl;
              this.eliminarDocumentosService.eliminarDocumentos(existente.idDocumento, rfc, existente.nombreDocumento).subscribe({
            next: (res) => {
              if (res.status === 204) {
                
                this.subirDocumento(rfc, idDocumentoTramite, file); // 👈 Subir nuevo PDF
              } else {
                Swal.fire('Error', 'No se pudo eliminar el documento anterior.', 'error');
              }
            },
            error: (err) => {
              if (err.status === 404) {
                
                this.subirDocumento(rfc, idDocumentoTramite, file); // 👈 Subir de todos modos
              } else {
                Swal.fire('Error', 'Error al eliminar el documento anterior.', 'error');
              }
            }
          });
          }
        });
          // Llamar a servicio para eliminar el documento existente  
        } else {

          this.archivoPDF4 = file;
            this.pdfURL4 = pdfSafeUrl;
          // No había documento previo, subir directamente
          this.subirDocumento(rfc, idDocumentoTramite, file);
        }
    }
  }

  // Evento de selección (opcional)
  archivoSelecionadoPDF4(event: Event, index: number): void {
    
  }

  // Abrir PDF en nueva pestaña
  abrirPDFNewVentana4(): void {
    if (this.pdfURL4) {
       const url = this.pdfURL4 as SafeResourceUrl;
      window.open((url as any).changingThisBreaksApplicationSecurity, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }


  //********************************** REPUVE *********************************************//

  onFileSelecteded5(input: HTMLInputElement, idDocumentoTramite: number): void {
    const file = input.files?.[0];
    const maxSizeMB = 2;
    const maxSizeBytes = maxSizeMB * 1024 * 1024;

    if (file) {
      if (file.type !== 'application/pdf') {
        Swal.fire({
          icon: 'error',
          title: 'Tipo de archivo no válido',
          text: 'Por favor selecciona un archivo PDF.',
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      if (file.size > maxSizeBytes) {
        Swal.fire({
          icon: 'error',
          title: 'Archivo demasiado grande',
          text: `El archivo supera el límite de ${maxSizeMB} MB.`,
          confirmButtonText: 'Aceptar',
          confirmButtonColor: '#A11A5C',
        });
        input.value = '';
        return;
      }

      
      // const objectUrl = URL.createObjectURL(file);
      // this.pdfURL5 = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
      // this.documentos[index].urlVisor = this.pdfURL5;
      // this.documentos[index].rawUrl = objectUrl;

      const datosPersona = this.SegundoGrupo.getRawValue();

      const rfc = datosPersona.rfc || '';
      
      const objectUrl = URL.createObjectURL(file);
      const pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);      

            
            //const existente  = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);
           
             // Buscar si ya hay documento anterior cargado para este tipo
              const existente = this.documentoList.find(doc => doc.idDocumentoTramite === idDocumentoTramite);
      
        if (existente) {

          Swal.fire({
              title: '¿Reemplazar archivo?',
              text: `Ya existe un archivo para "TENENCIA Y/O REFRENDO". ¿Deseas eliminar el anterior y subir el nuevo?`,
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#41bd00',
              cancelButtonColor: '#C71128',
              confirmButtonText: 'Sí, reemplazar',
              cancelButtonText: 'No, cancelar'
            }).then((result) =>{
              if(result.isConfirmed){

                this.archivoPDF5 = file;
                this.pdfURL5 = pdfSafeUrl;

                this.eliminarDocumentosService.eliminarDocumentos(existente.idDocumento, rfc, existente.nombreDocumento).subscribe({
            next: (res) => {
              if (res.status === 204) {
                
                this.subirDocumento(rfc, idDocumentoTramite, file); // 👈 Subir nuevo PDF
              } else {
                Swal.fire('Error', 'No se pudo eliminar el documento anterior.', 'error');
              }
            },
            error: (err) => {
              if (err.status === 404) {
                
                this.subirDocumento(rfc, idDocumentoTramite, file); // 👈 Subir de todos modos
              } else {
                Swal.fire('Error', 'Error al eliminar el documento anterior.', 'error');
              }
            }
          });
              }
            });
          // Llamar a servicio para eliminar el documento existente
          
        } else {
          this.archivoPDF5 = file;
          this.pdfURL5 = pdfSafeUrl;
          // No había documento previo, subir directamente
          this.subirDocumento(rfc, idDocumentoTramite, file);
        }
    }
  }

  // Evento de selección (opcional)
  archivoSelecionadoPDF5(event: Event, index: number): void {
  }

  // Abrir PDF en nueva pestaña
  abrirPDFNewVentana5(): void {
    if (this.pdfURL5) {
      const url = this.pdfURL5 as SafeResourceUrl;
      window.open((url as any).changingThisBreaksApplicationSecurity, '_blank');
    } else {
      Swal.fire({
        icon: 'warning',
        title: '¡Aviso!',
        text: 'Para visualizar el documento, primero debes seleccionar uno.',
        confirmButtonText: 'Aceptar',
        confirmButtonColor: '#A11A5C',
      });
    }
  }
  //********************************FUNCIONES*********************************************** */

  // Méto do que "transfiere" valor automáticamente del RFC al CURP
  pasarValorRfcACurp(): void {
    const rfc = this.SegundoGrupo.get('rfc')?.value;

    if (rfc && rfc.length >= 10) {
      const curpParcial = rfc.substr(0, 10).toUpperCase(); // Convertir a mayúsculas
      this.SegundoGrupo.get('curp')?.setValue(curpParcial);
    } else {
      // Caso en que el RFC no tenga los caracteres necesarios
      this.SegundoGrupo.get('curp')?.setValue('');
    }
  }

  // funcion para abrir modal curp
  modalCURP() {
    Swal.fire({
      background: 'rgba(161, 26, 92)',
      imageUrl: '/assets/img/imagenesCuerpo/CURP.png',
      imageWidth: '95%',
      imageHeight: 'auto',
      showCloseButton: true,
      showConfirmButton: false,
      width: '60%',
      showClass: {
        popup: `
            animate__animated
            animate__fadeInUp
            animate__faster
          `,
      },
      hideClass: {
        popup: `
                  animate__animated
                  animate__fadeOutDown
                  animate__faster
                `,
      },
    });
  }

  // funcion para abrir modal rfc
  modalRFCFISICA() {
    Swal.fire({
      background: 'rgba(161, 26, 92)',
      imageUrl: '/assets/img/imagenesCuerpo/RFCFISICA.png',
      imageWidth: '95%',
      imageHeight: 'auto',
      showCloseButton: true,
      showConfirmButton: false,
      width: '60%',
      showClass: {
        popup: `
            animate__animated
            animate__fadeInUp
            animate__faster
          `,
      },
      hideClass: {
        popup: `
                  animate__animated
                  animate__fadeOutDown
                  animate__faster
                `,
      },
    });
  }

  // funcion para descargar documento


  // funcion para extraer la fecha nacimento del rfc
  extractBirthday(): void {
    const rfc: string = this.SegundoGrupo.get('rfc')?.value;

    if (rfc && rfc.length >= 10) {
      // Obtener el año (posiciones 5 y 6 del RFC)
      let anio: string = rfc.substring(4, 6).trim();
      const anioInt: number = parseInt(anio, 10);

      if (anioInt > new Date().getFullYear() % 100 || anio === '00') {
        anio = (anio === '00') ? '2000' : '19' + anio;
      } else {
        anio = '20' + anio;
      }

      // Obtener mes y día
      const mes: string = rfc.substring(6, 8).trim();
      const dia: string = rfc.substring(8, 10).trim();

      const fechaNacimiento = `${anio}-${mes}-${dia}`;
      this.SegundoGrupo.get('fechaNacimiento')?.setValue(fechaNacimiento);
    } else {
      this.SegundoGrupo.get('fechaNacimiento')?.setValue('');
    }
  }

  // funcion para extraer el sexo del CURP
  extraerSexoDesdeCurp(): void {
    const curp: string = this.SegundoGrupo.get('curp')?.value;

    if (curp && curp.length >= 18) {
      const sexo = curp.charAt(10).toUpperCase();

      if (sexo === 'H') {
        this.SegundoGrupo.get('sexo')?.setValue('M');
      } else if (sexo === 'M') {
        this.SegundoGrupo.get('sexo')?.setValue('F');
      } else {
        this.SegundoGrupo.get('sexo')?.setValue('');
      }
    } else {
      this.SegundoGrupo.get('sexo')?.setValue('');
    }
  }
}
